import type { FeatureFlag } from '#/domain/featureFlag/FeatureFlag'
import type { FeatureFlagRepository } from '#/domain/featureFlag/FeatureFlagRepository'

export interface FeatureFlagListResult {
  flags: FeatureFlag[]
  partialFailureCount: number
}

export class GetAllProductsFeatureFlagsUseCase {
  constructor(private readonly repository: FeatureFlagRepository) {}

  async execute(): Promise<FeatureFlagListResult> {
    const products = await this.repository.findProducts()
    const results = await Promise.allSettled(
      products.map((product) => this.repository.findByProduct(product)),
    )
    const flags = results
      .filter((r): r is PromiseFulfilledResult<FeatureFlag[]> => r.status === 'fulfilled')
      .flatMap((r) => r.value)
    const partialFailureCount = results.filter((r) => r.status === 'rejected').length

    return { flags, partialFailureCount }
  }
}
